"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../util");
var common_1 = require("./common");
exports.defaultOptions = {
    bridgeName: 'DidiJSBridge',
    bridgeEvent: 'DidiJSBridgeReady'
};
var msgId = 0;
var callbackQueues = [];
function initBridge(bridgeName, bridgeEvent, system) {
    var _this = this;
    var bridge = window[bridgeName];
    var args = arguments;
    if (bridge) {
        if (system === 'ios' && bridge.init) {
            try {
                bridge.init();
            }
            catch (e) { }
        }
        util_1.each(callbackQueues, function (callback) {
            callback(bridge);
        });
    }
    else {
        document.addEventListener(bridgeEvent, function () {
            initBridge.apply(_this, args);
        }, false);
    }
}
function getBridge(bridgeName, callback) {
    var bridge = window[bridgeName];
    if (bridge) {
        callback(bridge);
    }
    else {
        callbackQueues.push(callback);
    }
}
function bridge(app, options) {
    options = __assign({}, exports.defaultOptions, options);
    setTimeout(function () {
        initBridge(options.bridgeName, options.bridgeEvent, app.system);
    }, 0);
    var cmnID = util_1.randomId();
    return function (method, params, callback) {
        if (callback === void 0) { callback = util_1.noop; }
        msgId++;
        var msgCode = cmnID + "_" + msgId;
        setTimeout(function () {
            getBridge(options.bridgeName, function (bridge) {
                bridge.callHandler(method, params, function (data) {
                    callback.call(this, data);
                    try {
                        util_1.logger({
                            pos: 'COMMUNICATION_BRIDGE_RES',
                            id: msgCode,
                            method: method,
                            params: JSON.stringify(data)
                        });
                    }
                    catch (e) { }
                });
                util_1.logger({
                    pos: 'COMMUNICATION_BRIDGE',
                    id: msgCode,
                    method: method,
                    params: JSON.stringify({
                        method: method,
                        params: params
                    })
                });
            });
        }, 0);
    };
}
exports.default = common_1.createCommunicationFactory(bridge, 'bridge');
